export default __webpack_public_path__ + "static/media/Nav_Story.c138df24.png";